import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const RPR = ensureStatuses({
	DEATHS_DESIGN: {
		id: 2586,
		name: 'Death\'s Design',
		icon: iconUrl(212926),
		duration: 30000,
	},

	// TODO: find out the duration on this, might be a pseudo-stance tho
	SOULSOW: {
		id: 2594,
		name: 'Soulsow',
		icon: iconUrl(212932),
	},

	SOUL_REAVER: {
		id: 2587,
		name: 'Soul Reaver',
		icon: iconUrl(217097),
		duration: 30000,
	},

	ENHANCED_HARPE: {
		id: 2845,
		name: 'Enhanced Harpe',
		icon: iconUrl(212939),
		duration: 20000,
	},

	ENHANCED_CROSS_REAPING: {
		id: 2591,
		name: 'Enhanced Cross Reaping',
		icon: iconUrl(212930),
		duration: 30000,
	},

	ENHANCED_VOID_REAPING: {
		id: 2590,
		name: 'Enhanced Void Reaping',
		icon: iconUrl(212929),
		duration: 30000,
	},

	ENHANCED_GALLOWS: {
		id: 2589,
		name: 'Enhanced Gallows',
		icon: iconUrl(212928),
		duration: 60000,
	},

	ENHANCED_GIBBET: {
		id: 2588,
		name: 'Enhanced Gibbet',
		icon: iconUrl(212927),
		duration: 60000,
	},

	ARCANE_CIRCLE: {
		id: 2599,
		name: 'Arcane Circle',
		icon: iconUrl(212936),
		duration: 20000,
	},

	CIRCLE_OF_SACRIFICE: {
		id: 2600,
		name: 'Circle of Sacrifice',
		icon: iconUrl(212937),
		duration: 5000,
	},

	BLOODSOWN_CIRCLE: {
		id: 2972,
		name: 'Bloodsown Circle',
		icon: iconUrl(212938),
		duration: 6000,
	},

	IMMORTAL_SACRIFICE: {
		id: 2592,
		name: 'Immortal Sacrifice',
		icon: iconUrl(217287),
		duration: 30000,
	},

	CREST_OF_TIME_BORROWED: {
		id: 2597,
		name: 'Crest of Time Borrowed',
		icon: iconUrl(212934),
		duration: 5000,
	},

	CREST_OF_TIME_RETURNED: {
		id: 2598,
		name: 'Crest of Time Returned',
		icon: iconUrl(212935),
		duration: 15000,
	},

	ENSHROUDED: {
		id: 2593,
		name: 'Enshrouded',
		icon: iconUrl(212931),
		duration: 30000,
	},

	IDEAL_HOST: {
		id: 3905,
		name: 'Ideal Host',
		icon: iconUrl(212944),
		duration: 30000,
	},

	PERFECTIO_OCCULTA: {
		id: 3859,
		name: 'Perfectio Occulta',
		icon: iconUrl(212942),
		duration: 30000,
	},

	PERFECTIO_PARATA: {
		id: 3860,
		name: 'Perfectio Parata',
		icon: iconUrl(212943),
		duration: 30000,
	},

	EXECUTIONER: {
		id: 3858,
		name: 'Executioner',
		icon: iconUrl(217198),
		duration: 30000,
	},
})
